import React, { useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { SubmittedFormModel } from "../../../services/api/types/forms/models/SubmittedFormModel";
import ModifySubmissionForm from "../molecules/ModifySubmissionForm";

interface Ref {
  show: (entry?: SubmittedFormModel) => void;
  close: () => void;
}

const ModifySubmissionModal = React.forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);
  const [entryState, setEntryState] = useState<SubmittedFormModel | null>(null);
  useImperativeHandle(ref, () => ({
    show: (entry) => {
      setEntryState(entry ?? null);
      setShowing(true);
    },
    close: handleClose,
  }));
  const handleClose = () => {
    setShowing(false);
  };

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title="Modify Submission"
      hasCancelButton
    >
      <ModifySubmissionForm entry={entryState} onClose={handleClose} />
    </ReusableModal>
  );
});

ModifySubmissionModal.displayName = "ModifySubmissionModal";
export { ModifySubmissionModal };
